import { createClient } from '@supabase/supabase-js'

const SUPABASE_URL = 'https://qfbeheliahjifgyzhqdw.supabase.co'
const SUPABASE_ANON = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InFmYmVoZWxpYWhqaWZneXpocWR3Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODAzNjE5NTEsImV4cCI6MjA5NTkzNzk1MX0.1_55L1W5wYj4q7nR066Rt5D9f8HnhBrpiti37oEtNY4'

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON)
